import React, { useRef, useState, useEffect, useCallback } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Modal, 
  Spinner
} from "react-bootstrap";
import { debounce } from "lodash"; // Import lodash debounce function
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg"
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import {
  coachUpdate,
} from "../../../utils/api";
import Camera from "../../../assets/images/Camera";
import Upload from "rc-upload";
import banner from "../../../assets/images/coach_details_banner.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import Loader from "../../../Loader/Loader";
import { PulseLoader } from "react-spinners";

import Cropper from "react-easy-crop";
import getCroppedImg from "../../../utils/getCroppedImg"; // A utility to extract cropped image blob



const DropdownSuggestions = ({ show, suggestions, handleSuggestionSelect }) => (
  <Dropdown show={show} className="mb-0">
    <Dropdown.Menu show={show}>
      {suggestions.length > 0 &&
        suggestions.map((suggestion) => (
          <Dropdown.Item
            key={suggestion.id}
            onClick={() => handleSuggestionSelect(suggestion)}
          >
            {suggestion.name}
          </Dropdown.Item>
        ))}
    </Dropdown.Menu>
  </Dropdown>
);

const EditProfileAbout = (props) => {
  const navigate = useNavigate();
  const { getUserFromToken, user } = useUserContext();
  const [about, setAbout] = useState(user.about ? user.about : "");
  const [isSubmitting, setisSubmitting] = useState(false);

  const MAX_CHARACTER_COUNT = 1500;
  const Min_CHARACTER_COUNT = 100;

  const [aboutError, setAboutError] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
    
  }, [user]);

  const handleDescription = (e) => {
    setAbout(e);
  };

  const onClickSave = async (values) => {
    try {
      setisSubmitting(true)

      if (
        (about && about?.length > MAX_CHARACTER_COUNT) ||
        !about ||
        (about && about?.length < Min_CHARACTER_COUNT)
      ) {
        setAboutError(true);
        setisSubmitting(false);
        return;
      } else {
        setAboutError(false);
      }


      if (about) {
        const formdata = new FormData();
        formdata.append("about", about);
        await coachUpdate(formdata);
      }
     
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      setisSubmitting(false)
    }

    getUserFromToken();
    setisSubmitting(false)
  };

  const tooltipAbout = (
    <Tooltip id="tooltip">
      Write something about you in up to 500 characters.
    </Tooltip>
  );


  return (
    <>
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
        {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Modal heading</Modal.Title>
        </Modal.Header> */}
        <Form>
          <Container>
            <Row className='g-3'>

              <Col sm="12" lg="12" className="mt-4">
                <div className="d-flex justify-content-between">
                  <Form.Label className="title">About</Form.Label>
                  <span>
                    <OverlayTrigger placement="top" overlay={tooltipAbout}>
                      <Image src={excl_i} />
                    </OverlayTrigger>
                  </span>
                </div>
                <SunEditor
                  // width="120%"
                  setDefaultStyle="font-family: Arial; font-size: 16px;"
                  setOptions={{
                    buttonList: [
                      ["undo", "redo"],
                      ["font", "fontSize"],
                      ["paragraphStyle", "blockquote"],
                      [
                        "bold",
                        "underline",
                        "italic",
                        // "strike",
                        // "subscript",
                        // "superscript",
                      ],
                      // ["fontColor", 
                      //   // "hiliteColor"
                      // ],
                      ["align", "list", "lineHeight"],
                      // ["outdent", "indent"],

                      // ["table", "horizontalRule", "link", "image", "video"],
                      // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                      // ['imageGallery'], // You must add the "imageGalleryUrl".
                      // ["fullScreen", "showBlocks", "codeView"],
                      // ["preview", "print"],
                      // ["removeFormat"],

                      // ["save", "template"],
                      // '/', Line break
                    ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                    defaultTag: "div",
                    height: 120,
                    showPathLabel: false,
                    // font: sortedFontOptions
                  }}
                  name="about"
                  setContents={about}
                  onChange={handleDescription}
                />
                {aboutError && (
                  <div className="text-danger">
                    About is Required & About section required minimum 250 and
                    maximum 1500 characters
                  </div>
                )}
                {/* {console.info("aboutError++ ", aboutError, storyError)} */}
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' onClick={onClickSave}>Save</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </Modal>
    </>
  );
}

export default EditProfileAbout;